import {internalApi} from "../../../common/axios";
import {useMutationBase, useQueryBase} from "../../../shared/hooks/useHookBase";
import toast from "react-hot-toast";
import {buildUrl} from "../../../shared/utils/net";
import {DATA_CONFIG_KEY} from "../../../shared/utils/enum";

const fetchSeasonThemeMasterData = async () => {
    const {data} = await internalApi.get(`season_theme_master`);
    return data.rows;
}

export const useSeasonThemeMasterData = () => {
    return useQueryBase(['seasonThemeMasterData'], fetchSeasonThemeMasterData, {staleTime: 0});
}

export const saveSeasonThemeMaster = async (data) => {
    try {
        const res = await internalApi.post('season_theme_master', {data});
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("저장 실패");
    }
}

export const deleteSeasonThemeMaster = async (seq) => {
    try {
        const res = await internalApi.delete(`season_theme_master/${seq}`);
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("삭제 실패");
    }
}